import React, { Component } from 'react';
import { CorrectTick } from '../../../assets/images';
import Skeleton from 'react-loading-skeleton';
import { UserAlert } from '../atoms/alerts';

class CommentSection extends Component {
  render() {
    if (this.props.loading) {
      return <Skeleton width='100%' height={this.props.loaderHeight} />;
    }

    if (!this.props.points.length) {
      return (
        <div className='bg-white p-5 border border-gray-200 rounded-md w-full h-44'>
          <UserAlert para='Data is not available' paraClasses=' font-semibold text-gray-600' imgClasses=' h-5 w-5' classes=' p-4'/>
        </div>
      );
    }

    const { points } = this.props;
    const length = points.length;

    return (
      <div
        className={`flex flex-col bg-white p-6 border overflow-hidden border-gray-200 rounded-md h-auto ${
          length === 3 ? 'justify-center' : ''
        } ${this.props.classes}`}
      >
        {points.map((item, index) => {
          return (
            <div className={`flex items-center ` + (index === length - 1 ? 'mb-0' : 'mb-6')} key={`${item}`+ index}>
              <img src={CorrectTick} className='mr-3' width='17' height='17' alt='correct_tick' />
              <div className='text-gray-700 text-sm'>
                <span className='text-gray-700 font-semibold'>{item.employee_count} &nbsp;employees &nbsp;</span>
                liked &nbsp;
                <span className='text-gray-700 font-semibold'>{item.category}</span>
              </div>
            </div>
          );
        })}
      </div>
    );
  }
}

CommentSection.defaultProps = {
  classes: '',
};

export default CommentSection;